<template>
  <div class="no-items-state">
    <vx-card class="no-items-card">
      <div class="no-items-content">
        <div class="no-items-icon">
          <FeatherIcon :icon="icon" size="64" :color="iconColor" />
        </div>
        <h2 class="no-items-title">{{ $t(title) }}</h2>
        <p class="no-items-description">
          {{ $t(description) }}
        </p>

        <div class="capture-options">

          <div v-if="inNoItemsSpace" class="capture-option space">
            <div class="option-icon">
              <FeatherIcon icon="FolderPlusIcon" size="24" color="#ff6b35" />
            </div>
            <div class="option-content">
              <h4>{{ $t('SubspacesHeader') }}</h4>
              <p>{{ $t('SubspacesDescription') }}</p>
              <a @click="()=> { this.$emit('create-subspace')}" style="cursor:pointer" class="option-link">
                {{ $t('CreateSubspace') }}
              </a>
            </div>
          </div>

          <div class="capture-option">
            <div class="option-icon">
              <FeatherIcon icon="EditIcon" size="24" color="#7367f0" />
            </div>
            <div class="option-content">
              <h4>{{ $t('ManualCreation') }}</h4>
              <p>{{ $t('ManualCreationDescription') }}</p>
              <a href="/pages/record" class="option-link">
                {{ $t('CreateManually') }}
              </a>
            </div>
          </div>

          <div class="capture-option">
            <div class="option-icon">
              <FeatherIcon icon="GlobeIcon" size="24" color="#4285f4" />
            </div>
            <div class="option-content">
              <h4>{{ $t('ChromeExtension') }}</h4>
              <p>{{ $t('ChromeExtensionDescription') }}</p>
              <a href="https://chromewebstore.google.com/detail/tcvelik-assistant/cfjhapiajpbhemmjjjhjppknflfbhmcj"
                 target="_blank" class="option-link">
                {{ $t('InstallExtension') }}
              </a>
            </div>
          </div>

          <div class="capture-option">
            <div class="option-icon">
              <FeatherIcon icon="MonitorIcon" size="24" color="#00d4aa" />
            </div>
            <div class="option-content">
              <h4>{{ $t('DesktopRecorder') }}</h4>
              <p>{{ $t('DesktopRecorderDescription') }}</p>
              <a href="/pages/record" class="option-link">
                {{ $t('OpenRecorder') }}
              </a>
            </div>
          </div>

          <div class="capture-option">
            <div class="option-icon">
              <FeatherIcon icon="SmartphoneIcon" size="24" color="#ff6b35" />
            </div>
            <div class="option-content">
              <h4>{{ $t('MobileRecording') }}</h4>
              <p>{{ $t('MobileRecordingDescription') }}</p>
              <a href="/pages/record" class="option-link">
                {{ $t('StartRecording') }}
              </a>
            </div>
          </div>
        </div>

        <div class="help-link">
          <p>
            {{ $t('MoreInformationText') }}
            <a href="https://www.tcvelik.com/help/capturing-options" target="_blank" class="help-link-text">{{ $t('Here') }}</a>.
          </p>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
  import FeatherIcon from "@/components/FeatherIcon.vue";

  export default {
    name: 'NoItemsCard',
    components: {
      FeatherIcon
    },
    props: {
      title: {
        type: String,
        default: 'NoSOPsAvailable'
      },
      description: {
        type: String,
        default: 'NoSOPsAvailableDescription'
      },
      icon: {
        type: String,
        default: 'BookOpenIcon'
      },
      iconColor: {
        type: String,
        default: '#7367f0'
      },
      inNoItemsSpace: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped>
  /* No Items State Styles */
  .no-items-state {
    padding: 2rem 0;
  }

  .no-items-card {
    max-width: 800px;
    margin: 0 auto;
    text-align: center;
  }

  .no-items-content {
    padding: 2rem;
  }

  .no-items-icon {
    margin-bottom: 1.5rem;
  }

  .no-items-title {
    font-size: 2rem;
    font-weight: 700;
    color: var(--vs-text);
    margin-bottom: 1rem;
  }

  .no-items-description {
    font-size: 1.1rem;
    color: var(--vs-text-secondary);
    line-height: 1.6;
    margin-bottom: 2rem;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }

  .capture-options {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1.5rem;
    margin-bottom: 2rem;
  }

  .capture-option {
    display: flex;
    align-items: flex-start;
    padding: 1.5rem;
    background: var(--vs-background);
    border-radius: 12px;
    border: 1px solid var(--vs-border);
    transition: all 0.3s ease;
    text-align:left;
  }

    .capture-option.space {
      grid-column: 1 / -1;
      width: minmax(250px, 1fr);
      max-width: 600px;
      margin: 0 auto;
      justify-content: center;
    }


    .capture-option:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
      border-color: var(--primary);
    }

  .option-icon {
    margin-right: 1rem;
    flex-shrink: 0;
  }

  .option-content h4 {
    font-size: 1.1rem;
    font-weight: 600;
    color: var(--vs-text);
    margin: 0 0 0.5rem 0;
  }

  .option-content p {
    font-size: 0.9rem;
    color: var(--vs-text-secondary);
    line-height: 1.5;
    margin: 0 0 1rem 0;
  }

  .option-link {
    display: inline-block;
    padding: 0.5rem 1rem;
    background: var(--primary);
    color: white !important;
    text-decoration: none;
    border-radius: 6px;
    font-size: 0.9rem;
    font-weight: 500;
    transition: all 0.3s ease;
  }

    .option-link:hover {
      background: var(--primary);
      transform: translateY(-1px);
      text-decoration: none;
      color: white !important;
    }

  .help-link {
    margin-top: 2rem;
    padding-top: 1.5rem;
    border-top: 1px solid var(--vs-border);
  }

    .help-link p {
      font-size: 0.95rem;
      color: var(--vs-text-secondary);
      margin: 0;
    }

  .help-link-text {
    color: var(--primary);
    text-decoration: none;
    font-weight: 500;
  }

    .help-link-text:hover {
      text-decoration: underline;
      color: var(--primary-dark);
    }

  /* Mobile Responsive */
  @media (max-width: 768px) {
    .capture-options {
      grid-template-columns: 1fr;
      gap: 1rem;
    }

    .capture-option {
      padding: 1rem;
    }

    .no-items-title {
      font-size: 1.5rem;
    }

    .no-items-description {
      font-size: 1rem;
    }
  }
</style>
